import apiClient from './apiClient';

export async function listCategories() {
  const { data } = await apiClient.get('/api/categories');
  return data;
}

export async function createCategory(payload) {
  const { data } = await apiClient.post('/api/admin/category', payload);
  return data;
}

export async function updateCategory(id, payload) {
  const { data } = await apiClient.put(`/api/admin/category/${id}`, payload);
  return data;
}
